import { Controller } from "@hotwired/stimulus"

// In-app help / hidden-gems panel, opened from the header "?" button. The
// panel renders at body level (so its fixed overlay isn't trapped by the
// header's backdrop-blur); the button and panel share this body-level scope.
// A list of topics; featured ones open a step-by-step guide in place.
export default class extends Controller {
  static targets = ["panel", "list", "guide"]

  open() {
    this.showList()
    this.panelTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
    this.escHandler = (e) => { if (e.key === "Escape") this.close() }
    document.addEventListener("keydown", this.escHandler)
  }

  close() {
    this.panelTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
    this.showList()
    if (this.escHandler) document.removeEventListener("keydown", this.escHandler)
  }

  openGuide(event) {
    const id = event.params.guide
    this.listTarget.classList.add("hidden")
    this.guideTargets.forEach((g) => g.classList.toggle("hidden", g.dataset.guide !== id))
  }

  backToList() {
    this.showList()
  }

  showList() {
    this.guideTargets.forEach((g) => g.classList.add("hidden"))
    this.listTarget.classList.remove("hidden")
  }

  disconnect() {
    document.body.classList.remove("overflow-hidden")
    if (this.escHandler) document.removeEventListener("keydown", this.escHandler)
  }
}
